import { EmojiText } from '@gagovictor/shared-frontend-core/dist/shared/components/Emoji';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import React from 'react';

import { useT } from '../../i18n';

interface Props {
    open: boolean;
    /** The streak that was lost. */
    streak: number;
    /** True after a video was closed early. */
    retry: boolean;
    busy: boolean;
    onAccept: () => void;
    onDecline: () => void;
}

/** A surprise, never a menu option: nothing else in the app says that a lost streak can come back. */
export const StreakRecoveryDialog: React.FC<Props> = ({
    open,
    streak,
    retry,
    busy,
    onAccept,
    onDecline,
}) => {
    const t = useT();
    return (
        <Dialog
            open={open}
            onClose={busy ? undefined : onDecline}
            maxWidth="xs"
        >
            <DialogTitle sx={{ fontWeight: 800 }}>
                <EmojiText>{t('streak.gift.title')}</EmojiText>
            </DialogTitle>
            <DialogContent>
                <Typography>
                    {t('streak.gift.body', { count: streak })}
                </Typography>
                {retry && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 1 }}
                    >
                        {t('streak.gift.retry')}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onDecline} disabled={busy}>
                    {t('streak.gift.decline')}
                </Button>
                <Button variant="contained" onClick={onAccept} disabled={busy}>
                    {t('streak.gift.accept')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
